export const AUTH_KEY_STORAGE = 'dev_token';
export const REFRESH_AUTH_KEY_STORAGE = 'dev_long_token';
export const CLASS_NAME_LAYOUT = 'main-content-view';
